// extracted by mini-css-extract-plugin
module.exports = {"head":"HeadChecker_head__3PVRc","headchecker":"HeadChecker_headchecker__2HCei","navigate":"HeadChecker_navigate__oomPb"};